import React from "react";
import { Field, ErrorMessage } from "formik";
import css from "./style.scss";
import classNames from "classnames";

const FormikCheckbox = ({ 
  name, 
  label, 
  id = null,
  className = '',
  labelClassName = '',
  containerClassName = '',
  required = false,
  errors = {},
  touched = {}
}) => {
  const fieldId = id || name;

  return (
    <Field name={name}>
      {({ field, meta }) => {
        // Use meta.error/meta.touched if available, otherwise fall back to props
        const hasError = (meta.error && meta.touched) || (errors[name] && touched[name]);
        const errorMessage = (meta.error && meta.touched) ? meta.error : (errors[name] && touched[name] ? errors[name] : null);
        
        return (
          <div className={classNames(css.clsFormGroup, containerClassName)}>
            <input 
              type="checkbox" 
              id={fieldId}
              {...field}
              checked={field.value || false}
              className={className}
            />
            <label 
              className={classNames(
                labelClassName,
                hasError && css.text_danger
              )} 
              htmlFor={fieldId}
            >
              {label}
              {required ? <span className={css.text_primary}>*</span> : null}
            </label>
            {errorMessage && (
              <div className={classNames(css.clsFormErrorText, css.text_danger)}>
                {errorMessage}
              </div>
            )}
            <ErrorMessage
              name={name}
              component="div"
              className="sr-only"
              style={{ display: 'none' }}
            />
          </div>
        );
      }}
    </Field>
  );
};

export default FormikCheckbox;

